// Minimal headless table wrapper with dark-mode classes consistent with the
// rest of the Studio UI.

import { ReactNode, HTMLAttributes, ThHTMLAttributes, TdHTMLAttributes } from "react";
import { cx } from "../lib/classNames";

export function Table({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableElement>) {
  return (
    <table
      className={cx("w-full border-collapse text-sm", className)}
      {...rest}
    >
      {children}
    </table>
  );
}

export function THead({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead className={cx("border-b border-slate-800 bg-slate-900/40", className)} {...rest}>
      {children}
    </thead>
  );
}

export function TBody({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody className={cx("divide-y divide-slate-800", className)} {...rest}>
      {children}
    </tbody>
  );
}

export function Tr({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr className={cx("hover:bg-slate-800/40 transition-colors", className)} {...rest}>
      {children}
    </tr>
  );
}

export function Th({
  className,
  children,
  ...rest
}: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cx(
        "px-4 py-2.5 text-left text-xs font-medium uppercase tracking-wider text-slate-400",
        className,
      )}
      {...rest}
    >
      {children}
    </th>
  );
}

export function Td({
  className,
  children,
  ...rest
}: TdHTMLAttributes<HTMLTableCellElement> & { readonly children?: ReactNode }) {
  return (
    <td
      className={cx("px-4 py-3 text-slate-200", className)}
      {...rest}
    >
      {children}
    </td>
  );
}
